"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zeroPad = exports.isDate = exports.getStartArray = exports.getPreviousMonth = exports.getNextMonth = exports.getMonthFirstDay = exports.getMonthDays = exports.getDateToShow = exports["default"] = exports.convertDate = exports.arrToDate = exports.WEEK_DAYS = exports.THIS_YEAR = exports.THIS_MONTH = exports.CALENDAR_WEEKS = exports.CALENDAR_MONTHS_FOR_DATE = exports.CALENDAR_MONTHS = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var THIS_YEAR = +new Date().getFullYear();
exports.THIS_YEAR = THIS_YEAR;
var THIS_MONTH = +new Date().getMonth() + 1;
exports.THIS_MONTH = THIS_MONTH;
var WEEK_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
exports.WEEK_DAYS = WEEK_DAYS;
var CALENDAR_MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
exports.CALENDAR_MONTHS = CALENDAR_MONTHS;
var CALENDAR_MONTHS_FOR_DATE = ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'];
exports.CALENDAR_MONTHS_FOR_DATE = CALENDAR_MONTHS_FOR_DATE;

var getStartArray = function getStartArray(date) {
  var dateArr = date.split('-');
  return [dateArr[0], +dateArr[1], +dateArr[2]];
}; // количество отображаемых недель


exports.getStartArray = getStartArray;
var CALENDAR_WEEKS = 6;
/**
 * добавить нужное количество 0 в начало строки - zeroPad(5, 2) => "05"
 * @param value
 * @param length
 * @returns {string}
 */

exports.CALENDAR_WEEKS = CALENDAR_WEEKS;

var zeroPad = function zeroPad(value, length) {
  return "".concat(value).padStart(length, '0');
};
/**
 * определить количество дней в месяце (28 - 31)
 * @param month
 * @param year
 * @returns {number}
 */


exports.zeroPad = zeroPad;

var getMonthDays = function getMonthDays() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  return 33 - new Date(year, month - 1, 33).getDate();
};
/**
 * получить номер первого дня месяца
 * @param month
 * @param year
 * @returns {number}
 */


exports.getMonthDays = getMonthDays;

var getMonthFirstDay = function getMonthFirstDay() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  return +new Date("".concat(year, "-").concat(zeroPad(month, 2), "-01")).getDay();
};
/**
 * проверка на валидность даты
 * @param date
 * @returns {boolean|*}
 */


exports.getMonthFirstDay = getMonthFirstDay;

var isDate = function isDate(date) {
  var isDate = Object.prototype.toString.call(date) === '[object Date]';
  var isValidDate = date && !Number.isNaN(date.valueOf());
  return isDate && isValidDate;
};
/**
 * формат даты для показа
 * @param date
 * @returns {*}
 */


exports.isDate = isDate;

var getDateToShow = function getDateToShow() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  if (!isDate(date)) return null;
  return [zeroPad(+date.getDate(), 2), zeroPad(+date.getMonth() + 1, 2), date.getFullYear()].join('.');
};
/**
 * формат даты для показа
 * @param date
 * @returns {*}
 */


exports.getDateToShow = getDateToShow;

var arrToDate = function arrToDate(arr) {
  return [arr[0], zeroPad(arr[1], 2), zeroPad(arr[2], 2)].join('-');
};
/**
 * преобразование даты для возврата 12.06.2019 -> 2019-06-12
 * @param strDate
 * @returns {string}
 */


exports.arrToDate = arrToDate;

var convertDate = function convertDate(strDate) {
  return strDate.split('.').reverse().join('-');
};
/**
 * получить предыдущий месяц
 * @param month
 * @param year
 * @returns {{month: number, year: number}}
 */


exports.convertDate = convertDate;

var getPreviousMonth = function getPreviousMonth(month, year) {
  var prevMonth = month > 1 ? month - 1 : 12;
  var prevMonthYear = month > 1 ? year : year - 1;
  return {
    month: prevMonth,
    year: prevMonthYear
  };
};
/**
 * получить следующий месяц
 * @param month
 * @param year
 * @returns {{month: number, year: *}}
 */


exports.getPreviousMonth = getPreviousMonth;

var getNextMonth = function getNextMonth(month, year) {
  var nextMonth = month < 12 ? month + 1 : 1;
  var nextMonthYear = month < 12 ? year : year + 1;
  return {
    month: nextMonth,
    year: nextMonthYear
  };
};
/**
 * сформировать массив чисел (каждое число [YYYY, MM, DD])
 * @param month
 * @param year
 * @returns {*[]}
 */


exports.getNextMonth = getNextMonth;

var _default = function _default() {
  var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : THIS_MONTH;
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THIS_YEAR;
  // получим количество дней в нужном месяце
  var monthDays = getMonthDays(month, year); // номер в неделе первого дня месяца

  var monthFirstDay = getMonthFirstDay(month, year); // сколько дней прошлого месяца показать

  var daysFromPrevMonth = monthFirstDay - 1 < 0 ? 6 : monthFirstDay - 1; // сколько дней будущего месяца показать

  var daysFromNextMonth = CALENDAR_WEEKS * 7 - (daysFromPrevMonth + monthDays); // получим следующий и прошлый месяца

  var _getPreviousMonth = getPreviousMonth(month, year),
      prevMonth = _getPreviousMonth.month,
      prevMonthYear = _getPreviousMonth.year;

  var _getNextMonth = getNextMonth(month, year),
      nextMonth = _getNextMonth.month,
      nextMonthYear = _getNextMonth.year; // количество дней в прошлом месяце


  var prevMonthDays = getMonthDays(prevMonth, prevMonthYear); // формируем массив чисел за прошлый месяц

  var prevMonthDates = _toConsumableArray(new Array(daysFromPrevMonth)).map(function (n, index) {
    var day = index + 1 + (prevMonthDays - daysFromPrevMonth);
    return [prevMonthYear, prevMonth, day];
  }); // формируем массив чисел за текущий месяц


  var thisMonthDates = _toConsumableArray(new Array(monthDays)).map(function (n, index) {
    var day = index + 1;
    return [year, month, day];
  }); // формируем массив чисел за будущий месяц


  var nextMonthDates = _toConsumableArray(new Array(daysFromNextMonth)).map(function (n, index) {
    var day = index + 1;
    return [nextMonthYear, nextMonth, day];
  }); // собираем общий массив


  return [].concat(_toConsumableArray(prevMonthDates), _toConsumableArray(thisMonthDates), _toConsumableArray(nextMonthDates));
};

exports["default"] = _default;